import React, { useRef, useState } from 'react';
import Globe, { OFFICES } from './Globe';
import { useScrollScene } from './motion';

const STAGES = [
  { name: 'Southern Africa', office: 0, countries: ['Zimbabwe', 'South Africa', 'Botswana', 'Zambia'], blurb: 'Our home. Headquarters in Harare, with a hub in Johannesburg for regional delivery.' },
  { name: 'East Africa', office: 1, countries: ['Kenya', 'Tanzania', 'Uganda', 'Rwanda'], blurb: 'Serving growing financial and telecom sectors across the region from our Johannesburg hub.' },
  { name: 'Europe', office: 2, countries: ['Czechia', 'Germany', 'Netherlands', 'United Kingdom'], blurb: 'Prague anchors our European practice, in the same time zone as our clients.' },
];
// Globe faces these [rotation, tilt] per stage (East Africa sits between the two African offices).
const AIM = [[31.05, -0.3], [36.8, -0.1], [14.44, 0.7]];

// Pinned scene: the globe turns to each region as you scroll.
const GlobalPresenceSection = () => {
  const ref = useRef(null);
  const view = useRef({ rot: 0.54, tilt: -0.3 });
  const [stage, setStage] = useState(0);

  useScrollScene(ref, (p) => {
    const i = Math.min(2, Math.floor(p * 3));
    const [lon, tilt] = AIM[i];
    view.current.rot = (lon * Math.PI) / 180;
    view.current.tilt = tilt;
    setStage((s) => (s === i ? s : i));
  });

  const s = STAGES[stage];
  return (
    <section ref={ref} className="relative h-[200vh] bg-[var(--surface)]">
      <div className="sticky top-0 h-screen overflow-hidden">
        <div className="absolute inset-0 grid-lines opacity-60" />
        <Globe view={view} className="absolute top-1/2 -translate-y-1/2 right-[-25%] md:right-[-8%] w-[110vw] md:w-[60vw] max-w-[900px] aspect-square opacity-60 md:opacity-100" />
        <div className="relative max-w-6xl mx-auto px-6 h-full flex flex-col justify-center">
          <p className="font-mono-label text-[var(--muted)] flex items-center gap-3 mb-8"><span className="text-[var(--red)]">04</span><span className="w-10 h-px bg-[var(--line-strong)]" />Global presence</p>
          <div key={stage} className="max-w-md" style={{ animation: 'fade 0.8s var(--ease)' }}>
            <h2 className="font-display text-6xl md:text-7xl leading-[0.95]">{s.name}</h2>
            <p className="mt-6 text-lg text-[var(--muted)] leading-relaxed">{s.blurb}</p>
            <ul className="mt-8 flex flex-wrap gap-2">
              {s.countries.map((c) => <li key={c} className="px-4 py-2 rounded-full border border-[var(--line-strong)] text-sm bg-[var(--glass)] backdrop-blur-sm">{c}</li>)}
            </ul>
          </div>
          <div className="absolute left-6 bottom-12 flex gap-3" aria-hidden>
            {STAGES.map((x, i) => <span key={x.name} className={`h-0.5 w-16 transition-colors duration-500 ${i <= stage ? 'bg-[var(--red)]' : 'bg-[var(--line-strong)]'}`} />)}
          </div>
        </div>
      </div>
      <style>{`@keyframes fade{from{opacity:0;transform:translateY(20px)}to{opacity:1;transform:none}}`}</style>
    </section>
  );
};

export default GlobalPresenceSection;
